import AppCards from "./components/AppCards";
import Table from "./components/Table";

import "./App.css";

function App() {
  return (
    <>
      <div className="App">
        <Table />
        <AppCards />
      </div>
      <div className="App-alternate">
        <h2>
          Oops! This page looks good only in landscape mode :( Maximize the page
          again
        </h2>
      </div>
    </>
  );
}

export default App;
